import { computed, watch } from "vue";
import { useI18n } from 'vue-i18n'

// 监听到语言发生改变后修改标题
export function useTitle(key) {
  const { t } = useI18n();

  // 对外暴露响应式数据（不可变 ref 对象）
  const titleRef = computed(() => {
    return t(key)
  })

  // 侦听响应式数据的变化并调用原生方法
  watch(titleRef, (newValue) => {
    document.title = newValue;
  }, {
    immediate: true,
  })

  // 虽然只有一个变量，但是按照习惯还是返回对象
  return {
    titleRef,
  };
}
